import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../lib/constants";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      aria-labelledby="faq-heading"
      className="py-24 md:py-32 border-t border-[#332C27] bg-gradient-to-b from-[#14110F] to-[#1a1614]"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-4 reveal">
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#F5A623] font-bold mb-4">
            / 06 — Questions
          </div>
          <h2
            id="faq-heading"
            data-testid="faq-heading"
            className="font-display text-4xl md:text-5xl lg:text-6xl text-[#F9FAFB] font-semibold uppercase tracking-tight leading-[1.05]"
          >
            Straight
            <br />
            <span className="text-[#F5A623]">answers.</span>
          </h2>
          <p className="mt-6 text-[#A19D98] text-base leading-relaxed">
            The stuff Lehigh Acres, Fort Myers and Cape Coral homeowners ask
            before they call. Still wondering? Reach out — we answer every
            message.
          </p>
        </div>

        <div className="lg:col-span-8 reveal">
          <ul className="divide-y divide-[#332C27] border-t border-b border-[#332C27]">
            {FAQS.map((item, i) => {
              const isOpen = open === i;
              return (
                <li key={item.q} data-testid={`faq-item-${i}`}>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-answer-${i}`}
                    data-testid={`faq-toggle-${i}`}
                    className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                  >
                    <span className="font-display text-lg md:text-xl text-[#F9FAFB] font-semibold tracking-tight group-hover:text-[#F5A623] transition-colors">
                      {item.q}
                    </span>
                    <span className="shrink-0 w-9 h-9 rounded-full border border-[#332C27] flex items-center justify-center text-[#F5A623] group-hover:border-[#F5A623]/60 transition-colors">
                      {isOpen ? (
                        <Minus className="w-4 h-4" />
                      ) : (
                        <Plus className="w-4 h-4" />
                      )}
                    </span>
                  </button>
                  {isOpen && (
                    <div
                      id={`faq-answer-${i}`}
                      data-testid={`faq-answer-${i}`}
                      className="pb-6 pr-12 text-[#A19D98] text-base leading-relaxed"
                    >
                      {item.a}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}
